<template>
	<CharacteristicEdit
		v-model="industrialSectors"
		ref="edit"
		:title="title"
		:with-keyword="true"
		keyword-placeholder="Branche, Produkte, Leistungen eingeben (mind. 3 Zeichen)"
		:characteristic-type="meta.industrialSectorType"
		:characteristic-items="meta.industrialSector"
		:nothing-allowed="nothingAllowed ? {
			overall: {
				inFan: true,
				text: 'Es sind alle Branchen möglich'
			}
		} : undefined"
		:title-formats="{
			default: 'Welchen Arbeitgeber im Bereich<br />%characteristicLabel%?',
			level: {
				1: title,
			}
		}"
		show-multiple-hint
		open-fan-label="Branchen auswählen"
		open-fan-label-with-selection="Branchen bearbeiten"
		label-type="application"
		:with-edit-button="withEditButton"
		:open-fan-button-alignment="buttonAlignment"
		:search-config="{ catalog: meta.searchCatalogIndustrialSector }"
		@input="$emit('input', $event)"
	/>
</template>

<script>
import CharacteristicEdit from "@/vue/characteristic/Edit.vue";
import {mapState} from "vuex";

export default {

	components: {
		CharacteristicEdit
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		withEditButton: {
			type: Boolean,
			required: false,
			default: true,
		},
		buttonAlignment: {
			type: String,
			required: false
		},
		nothingAllowed: {
			type: Boolean,
			required: false,
			default: true,
		}
	},

	data ()
	{
		return {
			industrialSectors: this.value
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		title ()
		{
			return 'Wunsch-Arbeitgeber:<br/>' +
				'Gib alle für dich interessanten Branchen eines zukünftigen Arbeitgebers an - das erhöht deine Chancen.'
		}
	},

	methods: {
		edit ()
		{
			this.$refs.edit.openFan();
		}
	}
}
</script>
